module.exports = __webpack_public_path__ + "img/login.38e14987.png";